import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './SubmitButton.css'

const SubmitButton = (props: UIProperties<SubmitButtonConfig>) => {
	const [isOver, setIsOver] = useState(false);
	const [isFinished, setIsFinished] = useState(false);
	useEffect(() => {

	}, [isOver])

	return (
		<div className="sb-fade-in modal-disable-select" style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			width: 'auto',
			
		}}>
			<button id={props.parameters.id} aria-label={props.parameters.ariaLbl ?? 'submit to patient records'} className="pointer" style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled || isFinished ? 'none' : 'all',
				width: '100%',
			}} onMouseOver={() => {
                if(props.parameters.highlightOnHover) {
                    setIsOver(true);
                }
			}} 
			aria-disabled={props.parameters.isDisabled}
			onMouseEnter={() => {
				var rollOverAudio = document.getElementById('button-rollover');
				if(!globals.isMuted) {
					(rollOverAudio as any).play();
				}
			}}
			onMouseDown={() => {
				setIsOver(true);
			}} onMouseUp={() => {
				setIsOver(false);
			}} onMouseOut={() => {
				setIsOver(false);
			}} onClick={() => {
				if(props.parameters.isDisabled) {
					return;
				}
				var clickAudio = document.getElementById('button-click');
				if(!globals.isMuted) {
					(clickAudio as any).play();
				}
				if(props.parameters.onClicked) {
					setIsFinished(true);
					props.parameters.onClicked();
				}
			}}>
				<img style={{
					pointerEvents: 'none',
					position: 'relative',
					filter: props.parameters.isDisabled || isFinished ? 'brightness(50%)' : 'brightness(100%)',
				}} src="./assets/images/general/buttons/button_submit_main.png"/>
				
				{isOver ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					height: '100%',
					pointerEvents: 'none',
				}} src="./assets/images/general/buttons/button_submit_down.png"/>) : (<div></div>)}
				{props.parameters.isDisabled || isFinished ? (<img style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                }} src={props.parameters.srcDisabled} />) : (<div></div>)}
				<p className="title-font" style={{
					position: 'absolute',
					margin: '0',
					left: '50%',
					top: '50%',
					transform: 'translate(-50%, -50%)',
					width: '100%',
					color: 'white',
					textShadow: '2px 3px 2px black',
					filter: props.parameters.isDisabled || isFinished ? 'brightness(50%)' : 'brightness(100%)',
				}}>Submit To Patient Records</p>
			</button>
		</div>
	);

};

export interface SubmitButtonConfig extends BaseConfig{
	top: string;
	left: string;
	id?: string;
	ariaLbl?: string;
    isDisabled?: boolean;
	srcDisabled?: string;
	highlightOnHover?: boolean;
	width: string;
	onClicked: () => void;
}

export default SubmitButton;